<template>
    <el-dialog title="合并支付记录" :visible.sync="dialog" width="1300px" :close-on-click-modal="false" >
      <BaseTable :tableData="tableData" :columns="columns" v-loading="loading">
        <!-- <template #offsetAmount="{ row }">
          <span v-if="row.deductionDirection === '出项'">
            -{{ row.offsetAmount}}
          </span>
          <span v-else>
            -{{ row.offsetAmount }}
          </span>
        </template> -->
      </BaseTable>
    </el-dialog>
</template>

<script>
import BaseTable from "@/components/BaseTable";
export default {
  name: "DeductionRecord",
  components: {
    BaseTable,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      total: 0,
      page: {
        size: 99999,
        current: 1
      },
      columns: [
        {
          prop: "settlementBatchName",
          label: "结算批次名称",
          showOverflowTooltip: true,
          width: 180,
        },
        {
          prop: "companyIdStr",
          label: "公司名称",
        },
        {
          prop:"allocatedAmount",
          label: "收到金额",
        },
        {
          prop: "createdByStr",
          label: "操作人",
        },
        {
          prop: "createTime",
          label: "操作时间",
          width: 135,
        },
      ],
      tableData: [],
    };
  },
  created() {
  },
  methods: {
    open(paymentId){
      this.dialog = true
      this.loading = true
      this.tableData = []
      this.axios({
        url: '/v1/web/payment-record-order-relation/list?paymentId=' + paymentId,
        method: 'get',
      }).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    dialogClose() {
      this.dialog = false
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.container_table {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 20px 20px;
}
</style>
